import { gql as t } from "@apollo/client";
import { AccountFragment as n, GameInfoFragment as e, InvitationFragment as o, VipLevelFragment as a } from "../fragment/account.js";
const m = t`
  query GetAccountDetail {
    getAccountDetail {
      account {
        ...Account
      }
      accountGameInfo {
        ...GameInfo
      }
      accountInvitation {
        ...Invitation
      }
      vipLevel {
        ...VipLevel
      }
    }
  }

  ${n}
  ${e}
  ${o}
  ${a}
`;
export {
  m as default
};
//# sourceMappingURL=getAccountDetail.js.map
